import $ from 'jquery';

$('.ManagerArea__input, .Modal--Login .Modal__input').on('focus', function() {
  setInputActive($(this));
});

$('.ManagerArea__input, .Modal--Login .Modal__input').on('blur', function() {
  if (!$(this).val().length) {
    setInputNotActive($(this));
  }
});

/**
 *
 * @param {JQuery} input
 */
function setInputActive(input) {
  input.parent().addClass('active');
}

/**
 *
 * @param {JQuery} input
 */
function setInputNotActive(input) {
  input.parent().removeClass('active');
}
